module.exports = __webpack_public_path__ + "media/images/tl/banner/th-dark-9d409a6714930e741e14f6f83cec9ab2.jpg";